import React from "react";
import { withRouter } from "react-router-dom";

import Stack from "components/common/Stack";
import CKYCauto from "components/Onboarding/CKYCauto";
import CKYCmanual from "components/Onboarding/CKYCmanual";

// import MenuItem from "components/common/MenuItem";

import { validationHelper } from "helper/validation";
import JarvisButton from "components/JarvisButton";
import { dateTimeHelper } from "helper/dateTime";
import { cameraHelper } from "helper/camera";
import { tracker } from "library/tracker";

import { localStore } from "stores/localStorage";
import { config } from "config";
import { masterApis } from "stores/master/masterApis";
import { jarvisPrimeOnboardingApis } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingApis";
import { resolveCkycFormData } from "helper/ckycPrefill";
import {
  buildKycUploadUpdate,
  buildMergedKycUploadDisplayState,
  emptyCkycDocStatus,
  kycDocumentUploadSucceeded,
  mergeCkycDocStatusWithUploadFlags,
  ckycStatusFlagsFromProps,
  didCkycVerificationChange,
} from "helper/kycDocumentUpload";
import {
  applyCkycUploadFailure,
  applyCkycUploadResult,
  areKycDocumentsReadyForSubmit,
  getCkycCustomerName,
  getKycUploadCatchMessage,
  isManualKycVerified,
  requestCkycDocumentVerify,
  validateKycDocumentUpload,
} from "helper/ckycDocumentVerify";

class CKYCContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        panNumber: "",
        aadharNumber: "",
        dateOfBirth: "",
        inputIdType: "C",
      },
      manageForm: {
        docType: "",
        docVerify: false,
      },
      formError: {
        aadharNumber: "",
        panNumber: "",
        dateOfBirth: "",
        customerName: "",
        panCard: "",
        aadharCardFront: "",
        aadharCardBack: "",
      },

      isImagesUploaded: {
        panCard: false,
        aadharCardFront: false,
        aadharCardBack: false,
      },

      documentVerifyStatus: mergeCkycDocStatusWithUploadFlags(
        emptyCkycDocStatus(),
        ckycStatusFlagsFromProps(props),
      ),

      imagesUploadingLoader: {
        panCard: false,
        aadharCardFront: false,
        aadharCardBack: false,
      },

      isVerified: false,
      isLoading: false,
      uploadedFiles: {
        panCard: null,
        aadharCardFront: null,
        aadharCardBack: null,
      },

      enableManually: true,
      hasFirstAttempError: false,
    };
    this.ckycUploadApplied = false;
  }

  syncCkycFormFromProps = () => {
    const { loginProfile, pan, dateOfBirth, aadharNumber } = this.props;
    this.setState((prev) => ({
      formData: {
        ...prev.formData,
        ...resolveCkycFormData(
          loginProfile,
          { pan, dateOfBirth, aadharNumber },
          prev.formData,
        ),
      },
    }));
  };

  componentDidMount() {
    if (
      localStore.isSsoCustomer() &&
      localStore.getSsoCustomerDetails()?.brokerName ===
      config.broker.ssoPlatform.centrum
    ) {
      this.props.history.replace({
        pathname: "/customer/document-signing",
        state: {
          returnURI: "/jarvis-prime/dashboard",
          callOrigin: "JARVIS_PRIME",
          productCode: config.productCodes.PRIME,
        },
      });
    }
    const { currentStagePrime, pan, dateOfBirth, aadharNumber } = this.props;
    this.syncCkycFormFromProps();

    if (currentStagePrime === 4) {
      this.setState((prev) => ({
        formData: {
          ...prev.formData,
          ...resolveCkycFormData(
            this.props.loginProfile,
            { pan, dateOfBirth, aadharNumber },
            prev.formData,
          ),
        },
        isVerified: true,
      }));
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.pan !== this.props.pan ||
      prevProps.dateOfBirth !== this.props.dateOfBirth ||
      prevProps.aadharNumber !== this.props.aadharNumber ||
      prevProps.loginProfile !== this.props.loginProfile
    ) {
      this.syncCkycFormFromProps();
    }

    if (prevProps.currentStagePrime !== this.props.currentStagePrime) {
      this.setState({ isVerified: this.props.currentStagePrime === 4 });
    }

    if (didCkycVerificationChange(prevProps, this.props) && !this.ckycUploadApplied) {
      this.setState((prev) => ({
        documentVerifyStatus: mergeCkycDocStatusWithUploadFlags(
          prev.documentVerifyStatus,
          ckycStatusFlagsFromProps(this.props),
        ),
      }));
    }
  }

  toggleKYCtype = (val) => {
    this.setState({ enableManually: val });
  };

  handleChange = ({ name, value }) => {
    if (name === "docType") {
      this.setState((prev) => ({
        manageForm: { ...prev.manageForm, [name]: value },
      }));
      return;
    }
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value },
      formError: { ...prev.formError, [name]: "" },
    }));
  };

  handleValidation = () => {
    const { formError, formData } = this.state;

    const panValidation = validationHelper.pan(formData.panNumber);
    formError.panNumber = panValidation.message;

    const dobValidation = validationHelper.dateOfBirth(formData.dateOfBirth);
    formError.dateOfBirth = dobValidation.message;

    this.setState({ formError });
    return panValidation.isValid && dobValidation.isValid;
  };

  //Verification Click
  handleVerification = async () => {
    if (!this.handleValidation()) {
      return;
    }

    const { formData } = this.state;
    this.setState({ isLoading: true });

    try {
      //event-tracker: Initial -> submit_ckyc
      tracker.initial.submitCkyc();
      const res = await masterApis.verfyAutoKYC({
        dateOfBirth: dateTimeHelper.dateOfBirth(formData.dateOfBirth),
        pan: formData.panNumber,
      });

      if (res.code == "KYC009") {
        await masterApis.submitKYCApi({ productCode: "PRIME" });
        this.setState({ isVerified: true }, () => {
          this.props.getOnboardingDataAction();
        });
        //event-tracker: Initial -> submit_ckyc_success
        tracker.initial.submitCkycSuccess();

        tracker.onboarding.ckyc(this.props.loginProfile.mobile);
      } else {
        this.setState({ hasFirstAttempError: true });
      }
      this.setImagesUploaded("panCard", res.panCardUploaded);
      this.setImagesUploaded("aadharCardFront", res.aadharCardFrontUploaded);
      this.setImagesUploaded("aadharCardBack", res.aadharCardBackUploaded);
    } catch (e) {
      //event-tracker: Initial -> submit_ckyc_error
      tracker.initial.submitCkycError({ error_msg: e.message });
      this.setState({ hasFirstAttempError: true });
      this.setImagesUploaded("panCard", e.panCardUploaded);
      this.setImagesUploaded("aadharCardFront", e.aadharCardFrontUploaded);
      this.setImagesUploaded("aadharCardBack", e.aadharCardBackUploaded);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleValidationReVerification = () => {
    const { formError, formData, isImagesUploaded, documentVerifyStatus } = this.state;
    const { disableUpload } = this.props;

    const panValidation = validationHelper.pan(formData.panNumber);
    formError.panNumber = panValidation.message;

    const dobValidation = validationHelper.dateOfBirth(formData.dateOfBirth);
    formError.dateOfBirth = dobValidation.message;

    const aadharValidation = validationHelper.aadhar(formData.aadharNumber);
    formError.aadharNumber = aadharValidation.message;

    const mergedImagesUploaded = buildMergedKycUploadDisplayState(
      {
        isPanUploaded: this.props.isPanUploaded,
        isAadhaarFrontUploaded: this.props.isAadhaarFrontUploaded,
        isAadhaarBackUploaded: this.props.isAadhaarBackUploaded,
      },
      this.props.crossProductKycUploadFlags,
      isImagesUploaded,
    );

    if (!areKycDocumentsReadyForSubmit(mergedImagesUploaded, disableUpload, documentVerifyStatus)) {
      formError.panCard = !mergedImagesUploaded.panCard
        ? "Verify PAN photo"
        : "";
      formError.aadharCardFront = !mergedImagesUploaded.aadharCardFront
        ? "Verify Aadhaar Front"
        : "";
      formError.aadharCardBack = !mergedImagesUploaded.aadharCardBack
        ? "Upload Aadhaar Back"
        : "";
      this.setState({ formError });
      return false;
    }

    this.setState({ formError });
    return (
      panValidation.isValid && dobValidation.isValid && aadharValidation.isValid
    );
  };

  // Re-verification Click
  handleReVerification = async () => {
    if (!this.handleValidationReVerification()) {
      return;
    }

    const { formData } = this.state;
    this.setState({ isLoading: true });

    try {
      //event-tracker: Initial -> submit_manual_ckyc
      tracker.initial.submitManualCkyc();
      const res = await masterApis.verifyManualKyc({
        panNumber: formData.panNumber,
        aadhaarNumber: formData.aadharNumber,
        dateOfBirth: formData.dateOfBirth,
        productCode: config.productCodes.PRIME,
      });

      if (isManualKycVerified(res)) {
        this.setState({ isVerified: true }, () => {
          this.props.getOnboardingDataAction();
        });
        //event-tracker: Initial -> submit_manual_ckyc_success
        tracker.initial.submitManualCkycSuccess();

        tracker.onboarding.ckyc(this.props.loginProfile.mobile);
      } else {
        this.props.setToast({ message: res.message });
      }
    } catch (e) {
      //event-tracker: Initial -> submit_manual_ckyc_success
      tracker.initial.submitCkycError({ error_msg: e.message });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleProceedDocumentSigningClick = async () => {
    let pathname = "/customer/document-signing";
    if (this.props.loginProfile.isManualAgreement === 1) {
      pathname = "/manual-document-signing";
    }
    this.props.history.push({
      pathname: pathname,
      state: {
        productCode: config.productCodes.PRIME,
        returnURI: "/jarvis-prime/onboarding",
      },
    });
  };

  readFileAsBlob = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      // Define onload event handler
      reader.onload = function (event) {
        const fileContent = event.target.result;
        const blob = new Blob([fileContent], { type: file.type });
        resolve(blob); // Resolve with the result when reading is complete
      };

      // Define onerror event handler
      reader.onerror = function (event) {
        reject(event.target.error); // Reject with the error if reading fails
      };

      // Start reading the file
      reader.readAsArrayBuffer(file);
    });
  };
  //   Uploading Image
  onBrowseClick = async ({ type, data = null, source } = {}) => {
    const customerName = getCkycCustomerName(this.props.loginProfile);
    const fieldValidation = validateKycDocumentUpload({
      type,
      formData: this.state.formData,
      customerName,
    });
    if (!fieldValidation.isValid) {
      this.setState((prev) => ({
        formError: {
          ...prev.formError,
          ...fieldValidation.errors,
        },
      }));
      if (fieldValidation.errors.customerName) {
        this.props.setToast({ message: fieldValidation.errors.customerName });
      }
      return;
    }

    let fileData = data;
    if (fileData?.name) {
      const fileName = fileData.name;
      const fileExtension = fileName.split(".").pop().toLowerCase();
      fileData.format = fileExtension;
    }

    const isNativeCamera =
      config.platform !== "WEB" && source === "camera";
    if (isNativeCamera) {
      fileData = await cameraHelper.getKycNativeDocumentPhoto();
    }

    if (!fileData) {
      return;
    }

    let file;
    if (isNativeCamera) {
      file = await cameraHelper.getBlobFromCameraPhoto(fileData);
      if (!file || file.size === 0) {
        this.props.setToast({
          message: "Could not read the photo. Please try again.",
        });
        return;
      }
    } else {
      file = await this.readFileAsBlob(fileData);
      if (!file || file.size === 0) {
        this.props.setToast({
          message:
            "Could not read the selected file. Please try again.",
        });
        return;
      }
    }

    const uploadExt = cameraHelper.extensionForKycUpload(fileData);

    const fileKB = file.size / 1024; // Converted in KB.
    if (fileKB > 10000) {
      const fileMB = (fileKB / 1000).toFixed(2);

      // if images are more than 10mb
      this.props.setToast({
        message: `Image must be less than 10MB, your Uploaded image is ${fileMB} MB`,
      });
      return;
    }

    this.setImagesUploadingLoader(type, true);
    // this.setImagesUploaded(type, false);
    try {
      // const res = await jarvisPrimeOnboardingApis.uploadKYCImages({
      //   customerId: this.props.loginProfile.customerId,
      //   file,
      //   typeKey: type,
      //   fileName: `${type}_${
      //     this.props.loginProfile.customerId
      //   }_${dateTimeHelper.now().getTime()}.${fileData.format}`,
      // });
      const res = await requestCkycDocumentVerify({
        type,
        file,
        fileName: `${type}_${this.props.loginProfile.customerId}_${dateTimeHelper
          .now()
          .getTime()}.${uploadExt}`,
        originalFileName: fileData?.name,
        productCode: config.productCodes.PRIME,
        loginProfile: this.props.loginProfile,
        formData: this.state.formData,
      });

      const succeeded = kycDocumentUploadSucceeded(res, type);
      this.setImagesUploaded(type, succeeded);
      this.ckycUploadApplied = true;
      this.setState((prev) => ({
        ...applyCkycUploadResult(prev, type, res),
        uploadedFiles: {
          ...prev.uploadedFiles,
          [type]: succeeded
            ? {
                fileName: `${type}_${this.props.loginProfile.customerId}`,
                verified: true,
              }
            : null,
        },
      }));
      this.props.updatePrimeOnboardingData(
        buildKycUploadUpdate(
          {
            isPanUploaded: this.props.isPanUploaded,
            isAadhaarFrontUploaded: this.props.isAadhaarFrontUploaded,
            isAadhaarBackUploaded: this.props.isAadhaarBackUploaded,
          },
          type,
          res,
        ),
      );
    } catch (e) {
      this.setImagesUploaded(type, false);
      this.setState((prev) => applyCkycUploadFailure(prev, type, getKycUploadCatchMessage(e), e));
    } finally {
      this.setImagesUploadingLoader(type, false);
    }
  };

  // setImagesUploaded = (type, value) => {
  //   const { isImagesUploaded } = this.state;
  //   isImagesUploaded[type] = value;
  //   this.setState({ isImagesUploaded });
  // };

  setImagesUploaded = (type, value) => {
    this.setState((prev) => ({
      isImagesUploaded: {
        ...prev.isImagesUploaded,
        [type]: value,
      },
    }));
  };

  // setImagesUploadingLoader = (type, value) => {
  //   const { imagesUploadingLoader } = this.state;
  //   imagesUploadingLoader[type] = value;
  //   this.setState({ imagesUploadingLoader });
  // };
  setImagesUploadingLoader = (type, value) => {
    this.setState((prev) => ({
      imagesUploadingLoader: {
        ...prev.imagesUploadingLoader,
        [type]: value,
      },
    }));
  };

  render() {
    const {
      formData,
      formError,
      isVerified,
      isLoading,
      enableManually,
      isImagesUploaded,
      imagesUploadingLoader,
      hasFirstAttempError,
      documentVerifyStatus,
    } = this.state;

    const {
      isPanUploaded,
      isAadhaarFrontUploaded,
      isAadhaarBackUploaded,
      crossProductKycUploadFlags,
      disableUpload,
    } = this.props;

    const mergedImagesUploaded = buildMergedKycUploadDisplayState(
      {
        isPanUploaded,
        isAadhaarFrontUploaded,
        isAadhaarBackUploaded,
      },
      crossProductKycUploadFlags,
      isImagesUploaded,
    );

    return (
      <Stack sx={{ flex: 1 }}>
        {/* CKYC Manual */}
        {enableManually ? (
          <CKYCmanual
            formData={formData}
            formError={formError}
            isVerified={isVerified}
            isLoading={isLoading}
            isImagesUploaded={mergedImagesUploaded}
            imagesUploadingLoader={imagesUploadingLoader}
            handleChange={this.handleChange}
            onBrowseClick={this.onBrowseClick}
            handleReVerification={this.handleReVerification}
            toggleKYCtype={this.toggleKYCtype}
            disableUpload={disableUpload}
            documentVerifyStatus={documentVerifyStatus}
          />
        ) : (
          // CKYC Auto
          <CKYCauto
            formData={formData}
            formError={formError}
            isVerified={isVerified}
            isLoading={isLoading}
            hasFirstAttempError={hasFirstAttempError}
            handleChange={this.handleChange}
            handleVerification={this.handleVerification}
            toggleKYCtype={this.toggleKYCtype}
          />
        )}

        {/* Submit: Doc signing */}
        {isVerified ? (
          <Stack
            direction="row"
            justifyContent={{ xs: "center", md: "flex-start" }}
            mb={3}
            mt={6}
            alignItems="center"
            sx={{ width: { xs: "100%", md: "auto" }, background: "#fff" }}
          >
            <Stack
              sx={{
                position: { xs: "fixed", md: "unset" },
                bottom: {
                  xs: "calc(10px + var(--safe-area-inset-bottom)) !important",
                  md: "unset",
                },
                width: { xs: "90vw", md: "unset" },
              }}
            >
              <JarvisButton
                loading={isLoading}
                onClick={this.handleProceedDocumentSigningClick}
                sx={{ width: { xs: "100%", md: "auto" } }}
              >
                Proceed to Client Agreement
              </JarvisButton>
            </Stack>
          </Stack>
        ) : null}
      </Stack>
    );
  }
}

export default withRouter(CKYCContainer);
